import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environment/environment';
import { BackendConnectorInterface } from './backend-connector.interface';

type QueryParams = Record<string, string | number | boolean | null | undefined>;

@Injectable({
  providedIn: 'root',
})
export class HttpClientService implements BackendConnectorInterface {
  readonly baseUrl = environment.apiUrl;

  private readonly httpClient: HttpClient = inject(HttpClient);

  public postRequest<TResponse, TBody = unknown>(
    path: string,
    body?: TBody,
    params?: QueryParams,
  ): Observable<TResponse> {
    return this.httpClient.post<TResponse>(this.urlBuilder(path), body, {
      params: this.buildHttpParams(params),
      responseType: 'json' as const,
    });
  }

  private urlBuilder(path: string) {
    return this.baseUrl + path;
  }

  private buildHttpParams(params?: QueryParams): HttpParams | undefined {
    if (!params) return undefined;
    const filtered: Record<string, string> = {};
    for (const [k, v] of Object.entries(params)) {
      if (v != null) filtered[k] = String(v);
    }
    return new HttpParams({ fromObject: filtered });
  }
}
